import { otherApiClient } from ".";
export const postPaymentConfirm = async (params)=>{
    const { data  } = await otherApiClient.market.post("/payments/confirm/toss", params);
    return data;
};
export const postZeroPayment = async (params)=>{
    const { data  } = await otherApiClient.market.post("/orders/".concat(params.orderId, "/confirm-zero-payment"));
    return data;
};
